import { render, staticRenderFns } from "./FloatToDoSidebar.vue?vue&type=template&id=189cc4de&scoped=true"
import script from "./FloatToDoSidebar.vue?vue&type=script&lang=js"
export * from "./FloatToDoSidebar.vue?vue&type=script&lang=js"
import style0 from "./FloatToDoSidebar.vue?vue&type=style&index=0&id=189cc4de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189cc4de",
  null
  
)

export default component.exports